export var MUST_BE_STRING = " Must be a string.";
export var MUST_BE_BOOLEAN = " Must be a boolean.";
export var isBoolean = function (param) { return typeof param === "boolean"; };
export var validateParam = function (param, paramName, isValid, isRequired, additionalInfo) {
    if (isRequired && !param) {
        return "".concat(paramName, " param is not defined.");
    }
    if (param && !isValid) {
        return "".concat(paramName, " param is not valid.").concat(additionalInfo);
    }
    return null;
};
export var validateEnum = function (param, enumsObj) {
    var enumsList = Object.keys(enumsObj);
    if (!enumsList.includes(param)) {
        return "Must be ".concat(enumsList.join(" or "));
    }
    return null;
};
export var validateArray = function (array, arrayValidator) {
    if (!Array.isArray(array)) {
        return "It must be an array";
    }
    else {
        var validationResult = array.map(function (object) { return arrayValidator(object); }).filter(function (object) { return object; });
        return validationResult.length === 0 ? null : validationResult[0];
    }
};
